export const ROUTES = {
  DEFAULT: '/',
  ERROR: '/error',
  DASHBOARD: '/dashboard',
  CHECKOUT_SUCCESS: '/checkout/success',
  SHIPPINGDETAILS: '/shipping-details/:id',
  BILLING: '/billing',
  BILLINGDETAILS: '/billing/details/:id',
  CONFIGURATIONS: '/configurations',
  CONFIGURATION_PREFERENCES: '/configurations/preferences',
  CONFIGURATION_CARRIER: '/configurations/carrier',
  CONFIGURATION_CARRIER_NAME: '/configurations/carrier/:name',
  SINGLE_SHIPMENT: '/single-shipment',
  SINGLE_SHIPMENT_QUOTATION: '/single-shipment/quotation',
  AGENCY_SHIPMENT: '/agency-shipment',
  AGENCY_SHIPMENT_QUOTATION: '/agency-shipment/quotation',
  REVERSE_SHIPMENT: '/reverse-shipment',
  REVERSE_SHIPMENT_QUOTATION: '/reverse-shipment/quotation',
  NEW_REVERSE_SHIPMENT_QUOTATION: '/new-reverse-shipment/quotation',
  DROPOFF_POINTS: '/dropoff_points/:type',
  NEW_SINGLE_SHIPMENT: '/create-single-shipment',
  NEW_SINGLE_SHIPMENT_QUOTATION: '/create-single-shipment/quotation',
  NEW_SINGLE_SHIPMENT_CUSTOMER: '/create-single-shipment/customer',
  NEW_SINGLE_SHIPMENT_REVIEW: '/create-single-shipment/review',
  BALANCE_STATUS: '/balance/:status',
  BALANCE_NUVEM_PAGO: '/balance/nuvem-pago',
  LANDING_PAGE: '/landing-page',
  SAVE_ON_SHIPPING: '/save-on-shipping',
  HEALTH: '/health',
  AUTH: '/auth'
};
